const TOKEN_KEY = "auth_token";
const THEME_KEY = "theme";

export function getAuthToken(): string | null {
  if (typeof window === "undefined") return null;
  return safeLocalStorageGet(TOKEN_KEY);
}

export function setAuthToken(token: string): void {
  safeLocalStorageSet(TOKEN_KEY, token);
}

/** Signs this browser out and drops Rooster transcripts, which may hold customer details. */
export function clearAuth(): void {
  safeLocalStorageRemove(TOKEN_KEY);
  try {
    Object.keys(localStorage).filter(key => key.startsWith("rooster_v1_")).forEach(safeLocalStorageRemove);
  } catch {
    // Storage can be unavailable in restricted browser modes.
  }
}

export function getTheme(): "light" | "dark" {
  if (typeof window === "undefined") return "light";
  return (localStorage.getItem(THEME_KEY) as "light" | "dark") || "light";
}

export function setTheme(theme: "light" | "dark"): void {
  localStorage.setItem(THEME_KEY, theme);
  if (theme === "dark") {
    document.documentElement.setAttribute("data-theme", "dark");
  } else {
    document.documentElement.removeAttribute("data-theme");
  }
}

function safeLocalStorageGet(key: string): string | null {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

function safeLocalStorageSet(key: string, value: string): void {
  try {
    localStorage.setItem(key, value);
  } catch {
    // Storage can be unavailable in restricted browser modes.
  }
}

function safeLocalStorageRemove(key: string): void {
  try {
    localStorage.removeItem(key);
  } catch {
    // Ignore storage failures during logout/session expiry cleanup.
  }
}
